<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11AUmMI/tc-custom/9780226384085.jpg?1734636257251" alt="This image is the cover for the book Cherubino's Leap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cherubino's Leap
      </h1>
      <p class="bookDescription body article font2">
        <p>For the Enlightenment mind, from Moses Mendelssohn’s focus on the moment of surprise at the heart of the work of art to Herder’s imagining of the seismic moment at which language was discovered, it is the flash of recognition that nails the essence of the work, the blink of an eye in which one’s world changes. <br/><br/> In <i>Cherubino’s Leap,</i> Richard Kramer unmasks such prismatic moments in iconic music from the Enlightenment, from the “chromatic” moment—the single tone that disturbs the thrust of a diatonic musical discourse—and its deployment in seminal instrumental works by Emanuel Bach, Haydn, and Mozart; on to the poetic moment, taking the odes of Klopstock, in their finely wrought prosody, as a challenge to the problem of strophic song; and finally to the grand stage of opera, to the intense moment of recognition in Gluck’s <i>Iphigénie en Tauride</i> and the exquisitely introverted phrase that complicates Cherubino’s daring moment of escape in Mozart’s <i>Figaro</i>. Finally, the tears of the disconsolate Konstanze in Mozart’s <i>Die Entführung aus dem Serail</i> provoke a reflection on the tragic aspect of Mozart’s operatic women. Throughout, other players from literature and the arts—Diderot, Goethe, Lessing among them—enrich the landscape of this bold journey through the Enlightenment imagination.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Kramer
      </h2>
      
      <p class="authorDescription body article"><B>Richard Kramer</B> is distinguished professor emeritus of music at the CUNY Graduate Center. A fellow of the American Academy of Arts and Sciences, he is the author of the award-winning <I>Distant Cycles: Schubert and the Conceiving of Song</I>, also published by the University of Chicago Press, and <I>Unfinished Music</I>.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cbe0e1e